import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import StatsSection from './components/StatsSection';
import CategorySection from './components/CategorySection';
import FeaturedAssets from './components/FeaturedAssets';
import ArticleSection from './components/ArticleSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'aigei',
  url: 'https://www.aigei.com',
  description: 'aigei 是国内领先的游戏素材、音效、音乐及视觉资源免费下载平台。提供海量高质量aigei音效下载、aigei游戏素材、aigei免费资源。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://www.aigei.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'aigei',
  url: 'https://www.aigei.com',
  description: '国内领先的游戏素材、音效、音乐及视觉资源免费下载平台',
  foundingDate: '2018',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '400-888-9999',
    contactType: 'customer service',
    availableLanguage: 'Chinese',
  },
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="首页"
        description="aigei 是国内领先的游戏素材、音效、音乐及视觉资源免费下载平台。无论您是独立游戏开发者、设计师还是内容创作者，aigei 提供海量高质量aigei音效下载、aigei游戏素材、aigei免费资源，助力您的项目快速落地。"
        keywords="aigei,aigei音效下载,aigei游戏素材,aigei免费资源,aigei素材库,aigei音乐素材,aigei视觉素材"
        canonicalUrl="/"
        schema={{ ...orgSchema }}
      />
      <script type="application/ld+json">{JSON.stringify(homeSchema)}</script>

      <main>
        <HeroSection />
        <StatsSection />
        <CategorySection />
        <FeaturedAssets />
        <ArticleSection />
        <FAQSection />
        <CTASection />
      </main>
    </>
  );
}